module.exports = __webpack_public_path__ + "img/brand-logo.11ec9517.svg";